module.exports = __webpack_public_path__ + "img/cj9100_center_001.714161b0.png";